/**
 * Round timing — the one definition of the multiplier curve.
 *
 * The backend settles money with these functions and the client predicts the
 * displayed multiplier with them, so both sides MUST use this exact file. The
 * frontend consumes a synced copy at frontend/src/shared/timing.js (CRA cannot
 * import from outside src/); `npm run sync-shared` refreshes it and CI fails if
 * the copy drifts.
 *
 * The curve is frozen alongside fairness engine version 1. Changing GROWTH
 * changes every historical verification, so it may only move with a new engine
 * version (see backend/crashEngine.js).
 *
 * Written as a UMD-ish module so Node (CommonJS) and the bundler both work.
 */
/* eslint-disable no-restricted-globals, strict */
/* global globalThis */
(function (root, factory) {
    if (typeof module === 'object' && module.exports) module.exports = factory();
    else root.SlopesTiming = factory();
}(typeof globalThis !== 'undefined' ? globalThis : this, function () {
    'use strict';

    // 1.0024 per 1/60 s == e^(ln(1.0024) * 60) per second.
    var GROWTH = Math.log(1.0024) * 60;

    /**
     * Multiplier shown at `now` for a round that went live at `start`.
     * Floored to two decimals, never below 1.00.
     * @param {number} start epoch ms the round went live
     * @param {number} [now] epoch ms to evaluate at
     * @returns {number}
     */
    function multiplierAt(start, now) {
        if (now === undefined) now = Date.now();
        var elapsed = Math.max(0, now - start);
        return Math.floor(Math.exp(GROWTH * elapsed / 1000) * 100) / 100;
    }

    /**
     * Exact epoch ms at which the curve reaches `multiplier`.
     * Inverse of multiplierAt before flooring, so settlement timestamps are exact.
     * @param {number} start epoch ms the round went live
     * @param {number} multiplier
     * @returns {number}
     */
    function timeAtMultiplier(start, multiplier) {
        return start + Math.log(multiplier) / GROWTH * 1000;
    }

    return { GROWTH: GROWTH, multiplierAt: multiplierAt, timeAtMultiplier: timeAtMultiplier };
}));
